module.exports = __webpack_public_path__ + "img/goods_01.7fa85b2d.jpg";